import { NavigationMenuItem } from '@models/navigation-menu-item';
import { IUser } from '@models/user';
import { zbFooterLinks } from '@shared/enums/footer-links';
import { zbAdminIntroVideoCodes } from '@shared/wistia/intro-video-codes';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

export const HELP_MENU_ID = 'help';

/**
 * Help dropdown for ZBPortal Teachers, District Administrators, and School Administrators.
 *
 * HLPortal and Parent menus keep the Help link from contact-us-menu.
 */
export const zbHelpMenu: NavigationMenuItem = {
  id: HELP_MENU_ID,
  label: 'Help',
  isRouted: false,
  isExternal: false,
  weight: 10,
};

/**
 * Builds the links shown in the ZBPortal Help dropdown.
 *
 * @param onWatchIntroVideo Opens the introduction video for the current role
 */
export function buildHelpDropdownMenuItems(onWatchIntroVideo: () => void): NavigationMenuItem[] {
  return [
    {
      id: 'introVideo',
      label: 'Watch the introduction video',
      description: 'Learn MyZBPortal features at your own pace.',
      zbpIconName: zbpIconNames.audioPlayIcon,
      isRouted: false,
      isExternal: false,
      onClickFunction: onWatchIntroVideo,
      weight: 1,
    },
    {
      id: 'techSupport',
      label: 'Get technical support',
      description: 'Have a question? We can help.',
      zbpIconName: zbpIconNames.question_mark,
      isRouted: true,
      isExternal: true,
      route: zbFooterLinks.support,
      weight: 2,
    },
  ];
}

/**
 * Gets the introduction video that plays on the user's first visit for the role they are viewing as.
 *
 * Checks roles in the same order the header builds menus: District Admin, School Admin, then Teacher.
 *
 * @param user The current user
 * @param teacherTutorialWistiaCode The Teacher introduction video, provided by the user status API
 */
export function getIntroVideoWistiaCode(user: IUser, teacherTutorialWistiaCode: string): string | null {
  if (!user) {
    return null;
  }

  if (user.isDistrictAdmin) {
    return zbAdminIntroVideoCodes.districtAdmin;
  }
  if (user.isSchoolAdmin) {
    return zbAdminIntroVideoCodes.schoolAdmin;
  }
  if (user.isTeacher) {
    return teacherTutorialWistiaCode || null;
  }
  return null;
}
